
// for refresh token
import axios from "axios";
import LoginUtil from "@/login/LoginUtil";
import urlUtil from "@/utils/urlUtil";

Window.refreshingToken = false;

const request = axios.create()

// timeout
request.defaults.timeout = 1000 * 60 * 10; // 10 minutes

request.defaults.baseURL = urlUtil.getBaseUrl();


request.interceptors.request.use(async function (config) {
    // Do something before request is sent
    const url = config.url
    console.log(url.url)
    let token = await LoginUtil.getAccessTokenAsync()
    if(token &&
        (config.url !== undefined && !config.url.includes('authenticate') && !config.url.includes('bio-auth') && !config.url.includes('refresh-token'))){
        config.headers.common['Authorization'] = `Bearer ${token}`
        config.withCredentials=true
    }

    config.timeout = 10 * 60 * 1000; // 10 mins

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});


// response interceptors
request.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx
    // if the response data is empty, set it to null
    if(response.data === ""){
        response.data = null
    }


    return response;
}, async (err) => {
    console.log(err)
    const originalConfig = err.config;
    if (originalConfig.url !== "/authenticate" && err.response && LoginUtil.getRefreshToken() !== "") {
        // Access Token was expired
        if (err.response.status == 401) {
            if(err.config.url !== "/refresh-token"){
                // if(!originalConfig._retry){
                //     originalConfig._retry = true;
                //     Window.refreshingToken = true
                //     try {
                //         // refresh the token
                //         const rs = await axios.put("/refresh-token", {
                //             token: LoginUtil.getRefreshToken(),
                //         });
                //
                //         // free other requests from giving errors
                //         Window.refreshingToken = false
                //
                //         LoginUtil.setAccessToken(rs.data.accessToken)
                //         LoginUtil.setRefreshToken(rs.data.refreshToken)
                //
                //         return axios(originalConfig);
                //     } catch (_error) {
                //         return Promise.reject(_error);
                //     }
                // } else{
                //     window.location.href = '/login'
                // }
            } else{
                // clear stored tokens
                // LoginUtil.resetRefreshToken()
                // LoginUtil.resetAccessToken()
                // reload
                // window.location.reload()
            }

        }
    }
    return Promise.reject(err);
});

export default request

export {
    request
}
